module.exports = __webpack_public_path__ + "img/vote_lowest.10164c93.svg";